export type StockSaleStatus = "approved" | "hold" | "recalled";
export interface StockSaleStatusSnapshot {
  version: "shop_stock_sale_status_v1";
  asOf: string;
  stockDocId: string;
  revision: number;
  shopSaleStatus: StockSaleStatus | "unreviewed";
  quantity: number;
  reservedQuantity: number;
}
export const stockSaleStatusId = (value: unknown): value is string => typeof value === "string" && /^[A-Za-z0-9_-]{1,128}$/.test(value);
const record = (value: unknown): value is Record<string, unknown> => !!value && typeof value === "object" && !Array.isArray(value);
export const validStockSaleStatus = (value: unknown): value is StockSaleStatus => typeof value === "string" && ["approved", "hold", "recalled"].includes(value);
export function isStockSaleStatusSnapshot(value: unknown): value is StockSaleStatusSnapshot {
  if (!record(value) || Object.keys(value).length !== 7 || value.version !== "shop_stock_sale_status_v1" || !stockSaleStatusId(value.stockDocId) ||
    typeof value.asOf !== "string" || !Number.isFinite(Date.parse(value.asOf)) || new Date(value.asOf).toISOString() !== value.asOf ||
    !Number.isSafeInteger(value.revision) || (value.revision as number) < 0 || (value.revision as number) > Number.MAX_SAFE_INTEGER - 1 ||
    !(validStockSaleStatus(value.shopSaleStatus) || value.shopSaleStatus === "unreviewed") ||
    !Number.isSafeInteger(value.quantity) || !Number.isSafeInteger(value.reservedQuantity)) return false;
  return (value.reservedQuantity as number) >= 0 && (value.quantity as number) >= (value.reservedQuantity as number);
}
export function isStockSaleStatusResult(value: unknown): value is { stockDocId: string; shopSaleStatus: StockSaleStatus; revision: number } {
  return record(value) && Object.keys(value).length === 3 && stockSaleStatusId(value.stockDocId) && validStockSaleStatus(value.shopSaleStatus) &&
    Number.isSafeInteger(value.revision) && (value.revision as number) > 0 && (value.revision as number) <= Number.MAX_SAFE_INTEGER - 1;
}
